// SPDX-License-Identifier: AGPL-3.0-or-later

import NewDeviceMonitoring from '@app/features/auth/state/NewDeviceMonitoring';
import {Switch} from '@app/features/ui/components/form/FormSwitch';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

const SHOW_NEW_DEVICE_ALERTS_DESCRIPTOR = msg({
	message: 'Show new device alerts',
	comment: 'Short label for an advanced voice device preference.',
});

export const NewDeviceAlertsControl = observer(() => {
	const {i18n} = useLingui();
	return (
		<Switch
			ariaLabel={i18n._(SHOW_NEW_DEVICE_ALERTS_DESCRIPTOR)}
			value={!NewDeviceMonitoring.suppressAlerts}
			onChange={(value) => NewDeviceMonitoring.setSuppressAlerts(!value)}
			compact
			data-flx="user.advanced-settings-tab.switch.new-device-alerts"
		/>
	);
});
